<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      clipped
      mobile-break-point="1600"
      class="white lighten-3"
      persistent
      temporary
    >
      <template v-if="permission!=null">
        <div style="height:50px;"></div>
        <section class="blue-grey lighten-4 pa-3">
          <h3>{{permission.enterprises[0].ent_name}}</h3>
          <router-link :to="`/`">
            <i class="fas fa-star" v-if="permission.enterprises[0].ent_type=='extreme'"></i>
            แพ็กเกจ{{permission.enterprises[0].package_text}}
          </router-link>
        </section>
        <v-divider></v-divider>
        <!--
        <h2 class="white--text text-xs-center">{{permission.role_id}}</h2>
        -->
        <v-list dense>
          <v-list-tile :to="`/`">
            <v-list-tile-content>
              <v-list-tile-title>แดชบอร์ด</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-subheader>เดลิเวอรี่</v-subheader>
          <v-list-tile :to="`/orders/live`">
            <v-list-tile-content>
              <v-list-tile-title>ออเดอร์วันนี้</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="`/orders/schedule`">
            <v-list-tile-content>
              <v-list-tile-title>ออเดอร์ล่วงหน้า</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-subheader>อีคอมเมิร์ซ</v-subheader>
          <v-list-tile :to="`/commerce/orders/live`">
            <v-list-tile-content>
              <v-list-tile-title>ออเดอร์สัปดาห์นี้</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-subheader>รายงาน</v-subheader>
          <v-list-tile :to="`/report/sale`">
            <v-list-tile-content>
              <v-list-tile-title>รายงานยอดขาย</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="`/report/shop`">
            <v-list-tile-content>
              <v-list-tile-title>รายงานตามร้านค้า/สาขา</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="`/report/category`">
            <v-list-tile-content>
              <v-list-tile-title>รายงานตามหมวดหมู่</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="`/report/product`">
            <v-list-tile-content>
              <v-list-tile-title>รายงานตามสินค้า</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile :to="`/report/heatmap`">
            <v-list-tile-content>
              <v-list-tile-title>การใช้งานตามพื้นที่</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <div v-if="['super_admin'].includes(permission.user.role_id)">
            <v-subheader>โซเชี่ยลมีเดีย</v-subheader>
            <v-list-tile :to="`/social/facebook`">
              <v-list-tile-content>
                <v-list-tile-title>Facebook</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </div>
          <v-subheader>ข้อมูล (CMS)</v-subheader>
          <v-list-tile
            :to="`/shops`"
            v-if="['super_admin', 'admin', 'enterprise_manager'].includes(permission.user.role_id)"
          >
            <v-list-tile-content>
              <v-list-tile-title>ร้านค้า</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <template v-if="['super_admin', 'admin'].includes(permission.user.role_id)">
            <v-subheader>Commerce</v-subheader>
            <v-list-tile :to="`/commerce/orders`">
              <v-list-tile-content>
                <v-list-tile-title>Orders</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="`/commerce/stores`">
              <v-list-tile-content>
                <v-list-tile-title>Stores</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="`/commerce/products`">
              <v-list-tile-content>
                <v-list-tile-title>Products</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-subheader>CMS</v-subheader>
            <v-list-tile :to="`/pois`">
              <v-list-tile-content>
                <v-list-tile-title>POI</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="`/posts`">
              <v-list-tile-content>
                <v-list-tile-title>Post</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-subheader>Others</v-subheader>
            <v-list-tile
              :to="`/enterprises`"
              v-if="['super_admin', 'admin'].includes(permission.user.role_id)"
            >
              <v-list-tile-content>
                <v-list-tile-title>Enterprises</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="`/users`">
              <v-list-tile-content>
                <v-list-tile-title>Users</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile :to="`/settings`">
              <v-list-tile-content>
                <v-list-tile-title>Settings</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <v-subheader>ผู้ใช้งาน</v-subheader>
          <v-list-tile @click="logout()">
            <v-list-tile-content>
              <v-list-tile-title>ออกจากระบบ</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </template>
    </v-navigation-drawer>
    <v-toolbar app fixed color="white" light>
      <v-toolbar-side-icon class="primary--text" @click.stop="drawer = !drawer">
        <img src="@/assets/img/hamburger-ico.png" style="width:100%;" />
      </v-toolbar-side-icon>
      <v-toolbar-title class="primary--text text-uppercase">
        <span class="font-weight-bold">{{enterprise_name}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content style="padding: 48px 0px 0px;">
      <router-view />
    </v-content>

    <v-footer :color="`#fafafa`" class="pa-3">
      <v-spacer></v-spacer>
      <div class="font-weight-bold text-xs-center grey--text">Halalize Co., Ltd © 2019 - 2020</div>
      <v-spacer></v-spacer>
    </v-footer>
    <v-dialog persistent v-model="newOrderDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">
          <v-spacer></v-spacer>มีออเดอร์มาใหม่
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-xs-center pa-3">
          <div>{{dialogMessage}}</div>
          <v-btn block depressed large color="green" dark @click="acceptOrder">ดูออเดอร์</v-btn>
          <v-spacer class="pa-2"></v-spacer>
          <v-btn block flat large class="red--text" @click="dismissDialog">ฉันกำลังทำงานอยู่.</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import Pusher from "pusher-js";
import Service from "../services";

import { mapState } from "vuex";

export default {
  name: "App",
  props: {
    source: String
  },

  computed: {
    // Map Vuex state.
  },
  data() {
    return {
      loading: true,
      drawer: null,
      drawerRight: null,
      right: false,
      left: false,
      permission: null,
      audio: new Audio(require("../assets/sounds/Bike_Horn.mp3")),
      loaded: false,
      newOrderDialog: false,
      dialogMessage: "",
      order_id: null,
      enterprise_name: null
    };
  },
  created() {
    /*
    setTimeout(() => {
      this.$store.dispatch("Auth/getPermission").then(data => {
        this.permission = data;
        this.loading = false;
        console.log(this.permission);
      });
    }, 500);
    */

    let pusher = new Pusher("671e1c26c1aae298ee23", {
      cluster: "ap1",
      forceTLS: false
    });

    Service.User.permission().then(resp => {
      this.permission = resp.data;

      let channel = null;
      if (this.permission.enterprises.length > 0) {
        this.enterprise_name = this.permission.enterprises[0].ent_name;
        channel = pusher.subscribe(
          "callcenter_ent" + this.permission.enterprises[0].ent_id
        );
      } else {
        this.enterprise_name = "HALALIZE";
        channel = pusher.subscribe("admin");
      }

      channel.bind("callcenter_neworder", data => {
        this.order_id = data.order_id;
        this.dialogMessage = "";
        this.audio.loop = false;
        this.audio.play();
        //this.dialogMessage = data.message;
        //this.newOrderDialog = true;

        this.$notify({
          title: "แจ้งเตือน",
          message: "[#" + data.order_id + "] มีออเดอร์มาใหม่",
          type: "warning",
          duration: 5000,
          onClick: () => {
            this.$router.push("/view/order/" + data.order_reference);
          }
        });
      });
    });

    pusher.connection.bind("connected", function() {
      console.log("pusher :: connected");
    });

    pusher.connection.bind("pusher:subscription_succeeded", function() {
      console.log("pusher :: pusher:subscription_succeeded");
    });

    pusher.connection.bind("connecting", function() {
      console.log("pusher :: connecting");
    });

    pusher.connection.bind("unavailable", function() {
      console.log("pusher :: unavailable");
    });
  },
  methods: {
    acceptOrder() {
      this.audio.pause();
      this.newOrderDialog = false;
      this.$router.push("/view/order/" + this.order_id);
    },
    dismissDialog() {
      this.audio.pause();
      this.newOrderDialog = false;
    },
    logout() {
      this.$store.dispatch("Auth/logout").then(res => {
        this.$router.go(this.$router.currentRoute);
      });
    }
  }
};
</script>
<style scoped lang="scss">
.v-list__tile__title {
  padding-left: 20px !important;
}
</style>
      